import { useEffect, useState } from 'react';
import { useFetchPostDataV2, setPath } from './useFetchData'
import { useQueryParams } from './useLocationData'
import productsMapping from '../data/mapping/pages/productsMapping';
import homepageMockData from '../data/homepage.json';
import productsRequest from '../data/requests/productsRequest.json';

const useProductsData = (pagePath) => {

  const queryKey = 'productsData' + pagePath;
  const queryParams = useQueryParams();
  const isMockData = queryParams.get('useMockData') === 'true';
  const requestBody = setPath(productsRequest, pagePath) ;
  const [productsQueryData, setGlobalData] = useState('');
  const { isLoading, error, data } = useFetchPostDataV2(queryKey, requestBody, isMockData);

  useEffect(() => {
      if (data && !isMockData) {
            const mappedData = productsMapping(data);
            setGlobalData(mappedData);
      }
  }, [data, isMockData])

  if (isMockData) {
    return {
      error: false,
      isLoading: false,
      productsQueryData: homepageMockData
    };
  }

  return  {
    error,
    isLoading,
    productsQueryData
  };
}

export default useProductsData;

